<div
  [ngClass]="[
    'basic-tooltip',
    'tooltip__size--' + size,
    'tooltip__position--' + position,
    'tooltip__variation--' + variation,
    'tooltip__orientation--' + orientation
  ]"
  [class.no_nubbin]="removeNubbin"
  (mouseenter)="checkOffScreen()"
  (mousedown)="checkOffScreen()"
>
  <div class="basic-tooltip__label" [class.basic-tooltip__label--no-label-styling]="noLabelStyling">
    <ng-content select="[label]"></ng-content>
  </div>
  <div class="basic-tooltip__tip" #tip>
    <div
      class="basic-tooltip__tip__content"
      [class.basic-tooltip__tip__content--fixto-left]="isLeftOffScreen"
      [class.basic-tooltip__tip__content--fixto-right]="isRightOffScreen"
      #tipContent
    >
      <ng-content select="[tip]"></ng-content>
    </div>
  </div>
</div>
